import { render, staticRenderFns } from "./ThongTinCongTyLuHanh.vue?vue&type=template&id=71e1ce33"
import script from "./ThongTinCongTyLuHanh.vue?vue&type=script&lang=js"
export * from "./ThongTinCongTyLuHanh.vue?vue&type=script&lang=js"
import style0 from "./ThongTinCongTyLuHanh.vue?vue&type=style&index=0&id=71e1ce33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports